import { environment } from '@y42/environment';
import { Diagram } from 'gojs';
import { DefineRoundedSideRectangles } from './utils/custom-figure-generator';

export function initGoJS() {
  Diagram.licenseKey = environment.gojs.key;
  DefineRoundedSideRectangles();
}
